import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-landing',
  templateUrl: './loader-landing.component.html',
  styleUrls: ['./loader-landing.component.css'],
  standalone: false
})
export class LoaderLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
